import { useState, useEffect } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../../domain/Auth/services/auth';
import { getData } from '../services/firestore/actions';
import { USERS } from '../services/firestore/constants/DbNameConstants';

export function useUserInfo() {
    const [user, loading, error] = useAuthState(auth);
    const [userInfo, setUserInfo] = useState(null);

    useEffect(() => {
        // console.log("SET")

        let mounted = true;
        const fetchData = async () => {
            // console.log(user)
            const data = await getData(USERS, user?.uid);

            // console.log(data);
            if (mounted) {
                setUserInfo(data as any);
                console.log("fetchData")
            }
        }
        fetchData()
        return () => { mounted = false };

    }, [user]);

    useEffect(() => {
        // console.log("LOADING", loading)
    }, [loading])

    return [userInfo, loading, error];
}